import { render, staticRenderFns } from "./PaymentFormCVSConfirm.vue?vue&type=template&id=1c81304c&scoped=true&lang=pug&"
import script from "./PaymentFormCVSConfirm.vue?vue&type=script&lang=js&"
export * from "./PaymentFormCVSConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFormCVSConfirm.scss?vue&type=style&index=0&id=1c81304c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81304c",
  null
  
)

export default component.exports